// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"socult_videoContainer__3kWyF","illuVideo":"socult_illuVideo__dV0Tt"};